import { env as commonEnv } from '../../utils';

// The environment store
export const env = {
  ...commonEnv,
};

export default env;
